module.exports = __webpack_public_path__ + "static/media/education-object-1-0-0.ae1cbdb4.png";